<template>
  <!-- 宝马课程选择 -->
  <div style="height: 100%;">
    <div class="ContentCss ContentCssType1" v-if="type == 1">
      <div class="TitleCss">
        <div>
          <img src="../../assets/imgs/logo.png" alt="" srcset="" />
          <div class="TitleName">课程选择</div>
        </div>
        <div class="SelectCss">
          <span>岗位</span>
          <el-select v-model.tirm="vType" placeholder="请选择" size="mini">
            <el-option
              :value="item.vtype"
              :label="item.vtype"
              v-for="item in vtypeList"
              :key="item.vtype"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="KCSelect">
        <div v-for="(item, index) in CurriculumList">
          <div class="Num">0{{ index + 1 }}</div>
          <div class="ShowItems">
            <p>
              <span>{{ item.title }}</span>
              <span class="ClickSpan" @click="HandelClick('find', item)"
                >查看课程></span
              >
            </p>
          </div>
          <div class="ShowProgress">
            <p>
              <span>学习进度</span
              ><span>
                <strong>{{ item.progress }}</strong> %</span
              >
            </p>
            <el-progress
              :text-inside="true"
              :stroke-width="18"
              :percentage="item.progress"
              color="#1B69D4"
              class="ProgressCss"
            >
            </el-progress>
          </div>
        </div>
      </div>
    </div>
    <div class="ContentCss" v-if="type == 2">
      <div class="TitleCss TitleCssType2">
        <div class="HistoryCss">
          <i class="el-icon-arrow-left" @click="HandelClick('history')"></i
          >{{ ClickType }}
        </div>
        <div>
          <img src="../../assets/imgs/logo.png" alt="" srcset="" />
        </div>
      </div>
      <!-- 课程训练 -->
      <div class="CourseTraining">
        <h3>Hi，欢迎进入AI课程！</h3>
        <p>{{ ClickType }}练习课程，请点击以下卡片对应模块进行学习。</p>

        <div class="ShowListType2" @mouseleave="ShowTid = ''">
          <div v-for="item in ShowType2List" :key="item.id">
            <div class="ShowContent" @mouseenter="ShowTid = item.id">
              <h2>
                {{ item.id }}
              </h2>
              <h4>
                {{ item.name }}
              </h4>
            </div>
            <transition name="fade">
              <div class="ShowContentCheck" v-if="ShowTid == item.id">
                <h2>
                  {{ item.id }}
                </h2>
                <h4>
                  {{ item.name }}
                </h4>
                <ul>
                  <li v-for="items in item.list" :key="items.id">
                    <span>{{ items.name }}</span>
                    <span @click="HandelClick('GO')">开始</span>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ShowTid: "",
      type: 1,
      ClickType: "",
      CurriculumList: [
        {
          title: "首保/定保电话招揽",
          id: 1,
          progress: 65
        },
        {
          title: "重点产品活动促销电话邀约",
          id: 2,
          progress: 78
        },
        {
          title: "重点产品增项-刹车片",
          id: 3,
          progress: 69
        },
        {
          title: "重点产品增项-轮胎",
          id: 4,
          progress: 72
        },
        {
          title: "重点产品增项-火花塞",
          id: 5,
          progress: 34
        }
      ],
      vtypeList: [],
      vType: "",
      ShowType2List: [
        {
          id: "01",
          name: "自主学习",
          list: [
            {
              id: 1,
              name: "单项训练-产品知识点"
            },
            {
              id: 2,
              name: "单项训练-需求异议"
            },
            {
              id: 3,
              name: "单项训练-价格异议"
            },
            {
              id: 4,
              name: "单项训练-权利异议"
            }
          ]
        },
        {
          id: "02",
          name: "单项训练",
          list: [
            {
              id: 1,
              name: "单项训练-产品知识点"
            },
            {
              id: 2,
              name: "单项训练-需求异议"
            },
            {
              id: 3,
              name: "单项训练-价格异议"
            },
            {
              id: 4,
              name: "单项训练-权利异议"
            }
          ]
        },
        {
          id: "03",
          name: "拟真场景训练",
          list: [
            {
              id: 1,
              name: "单项训练-产品知识点"
            },
            {
              id: 2,
              name: "单项训练-需求异议"
            },
            {
              id: 3,
              name: "单项训练-价格异议"
            },
            {
              id: 4,
              name: "单项训练-权利异议"
            }
          ]
        }
      ]
    };
  },
  // 路由判断
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    console.log(to, from, next);
    if (this.type == 1 || to.name == "VoiceExamination") {
      next();
    } else {
      this.type -= 1;
    }
  },
  methods: {
    // 获取录音类型
    getvtypeFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getvtype", {
          cid: "bztest",
          actname: ""
        })
        .then(res => {
          loading.close();
          this.vtypeList = res.data;
        });
    },
    // 操作
    HandelClick(type, data) {
      if (type == "find") {
        this.ClickType = data.title;
        this.type = 2;
        return;
      }
      if (type == "history") {
        this.type = 1;
        return;
      }
      if (type == "GO") {
        window.location.href = `${window.location.origin}/Manage/VoiceChat2.html?page=Fuction&cid=BZTEST&username=btest`;
      }
    }
  },
  created() {
    // 录音类型
    this.getvtypeFun();
  }
};
</script>
<style scoped>
.ContentCss {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.ContentCssType1 {
  background-image: url("../../assets/imgs/CurriculumBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.TitleCss {
  height: 66px;
  background: rgba(255, 255, 255, 0.49);
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  min-height: 66px;
  align-items: center;
}

.TitleCss img {
  width: 39px;
  height: 39px;
  display: block;
  margin-right: 9px;
}

.SelectCss {
  display: flex;
  align-items: center;
}

.SelectCss span {
  margin-right: 20px;
  font-size: 12px;
  color: #3c3e43;
}

.KCSelect > div {
  width: 361px;
  height: 206px;
  background-color: rgba(255, 255, 255, 0.9);
  margin-right: 100px;
  margin-top: 100px;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 1px 3px 5px rgba(0, 108, 255, 0.14);
}

.KCSelect > div:nth-of-type(3n) {
  margin-right: 0;
}

.KCSelect {
  box-sizing: border-box;
  padding: 0 70px;
  padding-top: 22px;
  display: flex;
  flex-wrap: wrap;
  width: 1440px;
  margin: 0 auto;
}

.Num {
  position: absolute;
  font-size: 100px;
  font-weight: bold;
  bottom: -35px;
  left: -35px;
  color: rgba(0, 108, 255, 0.06);
  z-index: 0;
}

.ShowItems {
  display: flex;
}

.ShowItems > p:first-of-type {
  display: flex;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px 0 22px;
  font-size: 20px;
  font-weight: bold;
  color: #3c3e43;
}

.ShowItems > p span {
  width: 210px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ShowItems > p .ClickSpan {
  width: 88px;
  height: 29px;
  text-align: center;
  line-height: 29px;
  font-size: 12px;
  color: #1b69d4;
  border: 1px solid #1b69d4;
  display: inline-block;
  cursor: pointer;
}

.TitleCss div:first-of-type {
  position: relative;
  display: flex;
  font-size: 24px;
  color: #262626;
  font-weight: bold;
  align-items: center;
}

.TitleCss .TitleName::after {
  width: 100%;
  content: "";
  position: absolute;
  bottom: 0px;
  height: 8px;
  background-color: #1b69d4;
  z-index: 1;
}

.ShowProgress {
  padding: 0 16px 0 22px;
  margin-top: 45px;
}

.ShowProgress p:first-of-type {
  display: flex;
  justify-content: space-between;
  color: #95b9e9;
  font-size: 14px;
  padding: 0;
  margin: 0;
}

.ShowProgress strong {
  font-size: 22px;
  color: #1b69d4;
}

.ProgressCss >>> .el-progress-bar__outer {
  background-color: rgba(0, 0, 0, 0.1);
}

/* 课程训练 */
.CourseTraining {
  padding-top: 72px;
  margin: 0 110px;
  flex: 1;
}

.CourseTraining h3 {
  font-size: 24px;
  margin: 0;
  padding: 0;
}

.TitleCssType2 {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
}

.HistoryCss {
  cursor: pointer;
}

.ShowListType2 {
  display: flex;
  justify-content: space-between;
}

.ShowListType2 > div {
  width: 365px;
  height: 491px;
  background-size: 355px 491px;
  background-repeat: no-repeat;
  background-position-x: 15px;
  display: flex;
  position: relative;
  flex-direction: column;
  /* overflow: hidden; */
}

.ShowListType2 > div:nth-of-type(1) {
  background-image: url("../../assets/imgs/one.png");
}

.ShowListType2 > div:nth-of-type(2) {
  background-image: url("../../assets/imgs/two.png");
}

.ShowListType2 > div:nth-of-type(3) {
  background-image: url("../../assets/imgs/three.png");
}

.ShowContent {
  width: 355px;
  height: 491px;
  position: absolute;
  left: 10px;
}

.ShowContent h2 {
  font-size: 60px;
  font-weight: bold;
  color: #fff;
  margin: 0;
  padding: 0;
  padding-left: 20px;
  margin-top: 300px;
}

.ShowContent h4 {
  font-size: 36px;
  color: #fff;
  font-weight: bold;
  margin: 0;
  padding: 0;
  padding-left: 20px;
}

.ShowContentCheck {
  width: 345px;
  background-color: rgba(0, 0, 0, 0.7);
  height: 480px;
  position: relative;
  left: 19px;
  top: 3px;
  border-radius: 3px;
  /* top: 498px; */
}

.ShowContentCheck::after {
  position: absolute;
  background-image: url("../../assets/imgs/jiantou.png");
  top: 50%;
  content: "";
  width: 25px;
  height: 34px;
  left: -4px;
  transform: translateX(-50%);
}

.ShowContentCheck h2 {
  color: #fff;
  padding: 0;
  margin: 0;
  font-size: 40px;
  padding-left: 17px;
  font-weight: bold;
}

.ShowContentCheck h4 {
  color: #fff;
  padding: 0;
  margin: 0;
  font-size: 30px;
  padding-left: 17px;
  font-weight: bold;
}

.ShowContentCheck ul {
  list-style: none;
  color: #fff;
  font-size: 16px;
  margin: 0;
  padding: 0;
  margin-top: 17px;
  margin-left: 20px;
  border-bottom: 1px solid #fff;
}

.ShowContentCheck ul li {
  display: flex;
  justify-content: space-between;
  padding-right: 25px;
  height: 77px;
  align-items: center;
  border-top: 1px solid #fff;
}

.ShowContentCheck ul li > span:nth-of-type(2) {
  display: inline-block;
  width: 74px;
  height: 28px;
  background: #1b69d4;
  border-radius: 2px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}

/* 可以设置不同的进入和离开动画

  /* 设置持续时间和动画函数 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
